import { render, staticRenderFns } from "./SuccessfullyChangedPassword.vue?vue&type=template&id=39721e88&scoped=true"
import script from "./SuccessfullyChangedPassword.vue?vue&type=script&lang=js"
export * from "./SuccessfullyChangedPassword.vue?vue&type=script&lang=js"
import style0 from "./SuccessfullyChangedPassword.vue?vue&type=style&index=0&id=39721e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39721e88",
  null
  
)

export default component.exports